import React from 'react';
import { Clear } from '@material-ui/icons';
import { IconButton } from '@material-ui/core';
import { PasslyButton } from '@app/components';

interface IProps {
    title: string;
    isOpen: boolean;
    isLoading?: boolean;
    onClose: () => void;
    onSubmit?: () => void;
    primaryBtnText?: string;
    secondaryBtnText?: string;
    isSubmitButtonDisabled?: boolean;
    children: JSX.Element;
}

export function RightSidebarModal(props: IProps) {
    const { title, isOpen, isLoading, onClose, onSubmit, primaryBtnText, secondaryBtnText, isSubmitButtonDisabled, children } = props;

    return (
        <div className={`right-panel ${isOpen ? 'open' : 'closed'}`}>
            <div className='right-panel__header'>
                <div>{title}</div>
                <IconButton size='small' color='inherit' onClick={onClose} aria-label='Close'>
                    <Clear fontSize='small' />
                </IconButton>
            </div>
            <div className='right-panel__body'>{children}</div>
            <div className='right-panel__footer'>
                <PasslyButton
                    onClick={onSubmit}
                    color='primary'
                    variant='contained'
                    type='button'
                    disabled={isSubmitButtonDisabled}
                    isLoading={isLoading}
                >
                    {primaryBtnText}
                </PasslyButton>
                <PasslyButton variant='outlined' onClick={onClose}>
                    {secondaryBtnText}
                </PasslyButton>
            </div>
        </div>
    );
}
